var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:_vm.className,attrs:{"fill":"none","height":_vm.height,"viewBox":"0 0 16 16","width":_vm.width,"xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{attrs:{"cx":"8","cy":"8","fill":_vm.background,"r":"8"}}),_vm._v(" "),_c('path',{attrs:{"d":"M9 2L5 9H8L7 14L11 7H8L9 2Z","fill":_vm.fill}})])
}
var staticRenderFns = []

export { render, staticRenderFns }